<template>
	<div class="modelprop">

		<div class="crumbs">
			
		    <el-breadcrumb separator=">">
		      <!--<el-breadcrumb-item :to="{ path: '/' }">当前位置</el-breadcrumb-item>-->
		      <span style="float: left;font-size: 100%;font-weight: 700;">当前位置&nbsp;:&nbsp;</span>
			  <el-breadcrumb-item><a style="color:#72ACE3;" >配置中心</a></el-breadcrumb-item>
			  <el-breadcrumb-item>弹窗中心</el-breadcrumb-item>
			</el-breadcrumb>
		    
		</div>
		<div class="main">
			<div class="page-controller">
		        <el-button type="primary"  style="margin-right: 20px;">弹窗模板库</el-button>
		        <router-link :to="{ path: '/createprop' }"><el-button>已创建弹窗</el-button></router-link>
		    </div>
		    <div class="page-list">
		        <div class="item-page" v-for="item in pageList" :key="item.EnumDesc">
		          <div class="item-inner">
		            <div class="cover-panel" :style="'background-image: url('+ item.ImgUrl +')'"></div>
			            <div class="cover-mask">
			              <div class="cover-inner">
			                <a class="cover-button" :href="previewPopAdress(item)" target="_blank">
			                  <el-button type="primary" size="small" round>预 览</el-button>
			                </a>
			                <!--<router-link class="cover-button" :to="{ name: 'exposureprop', params: {activity_id: 0, template_id: item.templateId} }">
			                  <el-button type="primary" size="small" round>创 建</el-button>
			                </router-link>-->
			                <el-button type="primary" size="small" @click="showConfirm(item.ExposureMode,item.EnumDesc,item.ExposureMode,item.EnumName)" round>创 建</el-button>
			              </div>
			            </div>
		          </div>
		          <p class="page-title">{{item.EnumName}}</p>
		        </div>
	      </div>
		</div>
		<!--对话框-->
		<!--<div v-show="isShowConfirm" class="confirm">
			<div class="confirm-title">
				<span id="titlestr">
					弹窗类型
				</span>
			</div>
			<div class="confirm-inp">
				<el-radio v-if="isVoucher" v-model="radio" label="2">出劵弹窗</el-radio>
				<el-radio v-model="radio" label="0">会场弹层</el-radio>
  				<el-radio v-model="radio" label="1">活动弹层</el-radio>
			</div>
			<div class="confirm-btn">
				<el-button @click="closeConfirm">取消</el-button>
  				<el-button @click="GoEdit" type="primary">确定</el-button>
			</div>
		</div>-->
		<el-dialog
			title="弹窗类型"
			:visible.sync="isShowConfirm"
			width="30%"
			top="30vh"
			>
			<div class="confirm-inp" style="text-align: center;padding-top:0">
				<el-radio v-if="isVoucher" v-model="radio" label="2">抽奖弹窗</el-radio>
				<el-radio v-model="radio" label="0">会场强弹</el-radio>
  				<el-radio v-model="radio" label="1">活动强弹</el-radio>
			</div>
			<div class="confirm-btn" style="height: 30px;line-height: 30px;text-align: right;margin-top: 20px;margin-right: 10px;">
				<el-button @click="closeConfirm">取消</el-button>
  				<el-button @click="GoEdit" type="primary">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Crunmbs from 'base/crumbs/crumbs'
	import {GetListTemplate} from 'api/create-activity'
	export default {
		data() {
			const domain = this._strUrl.getUrl();
   			const address = '/platformv2/module/image'
		    return {
		    	dialogVisible: true,
		      	superiorCatalogue: {
		          currentText: '弹层中心'
		        },
		        TempName:"",     //弹窗名称
		        ExposureMode:"",  //曝光方式
		        radio: '2',     //单选框的值,默认选中弄出劵弹窗
		        isShowConfirm:false,   //控制对话框显不显示
		        isVoucher:true,		   //控制出劵显不显示
		        templateId:"",         //模板 id 
		        pageList: [
			        {
			          img: `${domain}${address}/toast-at.png`,
			          text: '红包弹层',
			          templateId: 'toast-at',
			          indirect:"1"    //是不是直接曝光，直接曝光是1，间接曝光是2
			        },
			        {
			          img: `${domain}${address}/toast-tg.png`,
			          text: '财神弹层',
			          templateId: 'toast-tg',   
			          indirect:2   	 //是不是直接曝光，直接曝光是1，间接曝光是2 
			        }
			    ]
		    }
	    },
	    components: {
		    Crunmbs
		},
		methods:{
			GoEdit(){   //跳转到编辑
				 this.$router.push({
			            name: 'exposureprop',
			            params: { 
			                activity_id: 0, 
			                template_id: this.templateId,
			                types_id:this.radio,
			                TempName:this.TempName,
			                ExposureMode:this.ExposureMode
			            }
			    })
				
			},
			closeConfirm(){    //关闭对话框
				this.isShowConfirm = false;
			},
			showConfirm(isindirect,id,ExposureModeID,TempName){    //显示对话框
				this.TempName = TempName;
				this.templateId = id;
				this.ExposureMode = ExposureModeID;
				if(isindirect == 0 || isindirect==2){   //证明是直接曝光
					this.isVoucher = true;
				}else if(isindirect == 1){    //证明是  间接曝光，这时不显示出劵弹窗，要默认选中会场弹层
					this.isVoucher = false
					this.radio = '0'
				}
				this.isShowConfirm = true;
			},
//			 :href="'http://test5.iadapi.mobjz.com/iad/entry?appkey=1D7F1F30B2B42C8482C74E8153249F46?activity_id=0&template_id='+ item.templateId"
			 // 预览弹层模板地址
		    previewPopAdress (popInfo) {
//		    	let adress = `${iadInfDomain}?appkey=1D7F1F30B2B42C8482C74E8153249F46?activity_id=0&template_id=${popInfo.templateId}`
		    	let adress = `${iadInfDomain}?appkey=${this._appKey.getAppKey()}`;
//		    	adress = `${adress}&back=1&actback=1&isvenue=1&meetlayerid=${popInfo.ActivityId}`;
		    	adress = `${adress}&layertemplate_id=${popInfo.EnumDesc}`;
		    	return adress
		    }
		},
		created(){
			
			GetListTemplate({
				typeid:2,
				editmode:1
			}).then(res=>{
				
				var imgurl = this._strUrl.getUrl() +"platformv2/module/image/";
				for(var i = 0;i<res.length;i++){
					res[i].ImgUrl = imgurl + res[i].EnumDesc+".png"
				}
				this.pageList = res
			})
		}
	}
</script>

<style lang="scss" scoped>
	
	.page-controller{
    	margin: 20px 0;
    	button{
    		width: 150px;
    		text-align: center;
    	}
  	}
  	.page-list{
	    .item-page{
	      float: left; width: 280px; margin: 0 30px 20px 0;
	      .item-inner{
	        &:hover{
	          border-color: #0eaaf0;
	          .cover-mask{
	            display: block;
	          }
	          .cover-panel{
	            background-position: bottom;
	          }
	        }
	      }
	    }
	    .item-inner{
	      position: relative; padding: 6px; border: 1px solid #ddd; border-radius: 4px; box-shadow: 4px 3px 6px #ddd;
	      .cover-mask{
	        display: none; position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 10; background: hsla(0, 0%, 100%, .5);
	        .cover-inner{
	          position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
	          .cover-button{
	            display: inline-block; color: #fff;
	            &:first-child{
	              margin-right: 10px;
	            }
	          }
	        }
	      }
	    }
	    .cover-panel{
	      height: 440px; background: no-repeat top; background-size: cover; transition: all 1.5s ease;
	    }
	    .page-title{
	      line-height: 26px; font-size: 14px; text-align: center; padding: 6px; font-weight: 700;
	    }
	}
	.crumbs{
	    margin-top: 10px; padding: 10px 10px 10px 8px; border-left: 2px solid #bbb; background: #f5f5f5;
	}
	.confirm {
		width: 30%;
		z-index: 2;
		background: white;
		position: absolute;
		left: 35%;
		top: 40%;
		font-size: 15px;
		font-family: "microsoft yahei";
		box-shadow: 0 0 2px #BBBBBB;
		.confirm-title{
			border-bottom: 1px solid #ECECEC;
			height: 40px;
			line-height: 50px;
			text-align: left;
			span{
				margin-left: 15px;
				font-size: 14px;
			}
		}
		.confirm-inp{
			height: 60px;
			border-bottom: 1px solid #ECECEC;
			line-height: 60px;
			
		}
		.confirm-btn{
			height: 45px;
			line-height: 45px;
			text-align: right;
			button{
				height: 20px;
				line-height: 0;
				margin-right: 15px;
			}
		} 
	}

</style>
<style>
	.modelprop .el-dialog{
		min-width: 410px;
	}
	.modelprop .el-dialog__header{
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/modelprop/modelprop.vue